import Container from "../Container";
import style from "./Loading.module.css";

const Loading = ({ message }: { message: string }) => (
  <Container className={style.loading}>{message}</Container>
);

export default Loading;
